import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import HoligramClub from "@/pages/HoligramClub";
import InvestorDemo from "@/pages/InvestorDemo";
import License from "@/pages/License";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import MyReservations from "@/pages/MyReservations";
import AdminPanel from "@/pages/AdminPanel";
import QuickCapture from "@/pages/QuickCapture";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AuthCallback from "@/pages/AuthCallback";
import Protected from "@/components/Protected";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";

// Detect Google OAuth return (hash contains session_id) — route synchronously to AuthCallback
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/hologram-club" replace />} />
      <Route path="/hologram-club" element={<HoligramClub />} />
      <Route path="/hologram-club/demo" element={<InvestorDemo />} />
      <Route path="/hologram-club/license" element={<License />} />
      <Route path="/license" element={<Navigate to="/hologram-club/license" replace />} />
      <Route path="/demo" element={<Navigate to="/hologram-club/demo" replace />} />
      {/* Backward-compat for the old misspelled route */}
      <Route path="/holigram-club" element={<Navigate to="/hologram-club" replace />} />
      <Route path="/holigram-club/*" element={<Navigate to="/hologram-club" replace />} />
      <Route path="/hologram" element={<Navigate to="/hologram-club" replace />} />
      <Route path="/club" element={<Navigate to="/hologram-club" replace />} />
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route path="/hologram-club/login" element={<Login />} />
      <Route path="/hologram-club/signup" element={<Signup />} />
      <Route
        path="/hologram-club/my-reservations"
        element={<Protected><MyReservations /></Protected>}
      />
      <Route
        path="/hologram-club/admin"
        element={<Protected adminOnly><AdminPanel /></Protected>}
      />
      <Route
        path="/hologram-club/admin/quick-capture"
        element={<Protected adminOnly><QuickCapture /></Protected>}
      />
      <Route path="/hologram-club/payment-success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="*" element={<Navigate to="/hologram-club" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-[#050505] min-h-screen text-white">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: { background: "#0B0C10", border: "1px solid rgba(0,229,255,0.35)", color: "#fff" },
        }}
      />
    </div>
  );
}

export default App;
